// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DFo8O","col":"styles_col__1sR_f"};